<script>
import { mapGetters } from "vuex";

const GAP = 16;

export default {
  name: "Bahn1Gallery",
  data: () => ({
    index: 0,
    viewportWidth: 0
  }),
  computed: {
    ...mapGetters("bahn1", ["bildergallerie"]),
    galleryItems() {
      return this.bildergallerie && this.bildergallerie.BilderItems
        ? this.bildergallerie.BilderItems.filter(item => item.Bild)
        : [];
    },
    itemWidth() {
      if (!this.viewportWidth) return 0;
      return (
        (this.viewportWidth - (this.visibleCount - 1) * GAP) / this.visibleCount
      );
    },
    step() {
      return this.itemWidth + GAP;
    },
    visibleCount() {
      if (this.$vuetify.breakpoint.xsOnly) return 1;
      if (this.$vuetify.breakpoint.smOnly) return 2;
      return 3;
    },
    maxIndex() {
      return Math.max(0, this.galleryItems.length - this.visibleCount);
    }
  },
  watch: {
    maxIndex(value) {
      if (this.index > value) this.index = value;
    },
    "galleryItems.length"() {
      this.$nextTick(this.setupViewportObserver);
    }
  },
  mounted() {
    this.$nextTick(this.setupViewportObserver);
  },
  beforeDestroy() {
    if (this.viewportObserver) this.viewportObserver.disconnect();
    window.removeEventListener("resize", this.updateViewportWidth);
  },
  methods: {
    setupViewportObserver() {
      const el = this.$refs.viewport;
      if (!el) return;
      this.viewportWidth = el.clientWidth;
      if (this.viewportObserver) this.viewportObserver.disconnect();
      if (typeof ResizeObserver !== "undefined") {
        this.viewportObserver = new ResizeObserver(entries => {
          this.viewportWidth = entries[0].contentRect.width;
        });
        this.viewportObserver.observe(el);
      } else {
        window.addEventListener("resize", this.updateViewportWidth);
      }
    },
    updateViewportWidth() {
      if (this.$refs.viewport) {
        this.viewportWidth = this.$refs.viewport.clientWidth;
      }
    },
    imageUrl(item) {
      return this.$store.getters.getStrapiImageUrl(item.Bild, "small");
    },
    prev() {
      const count = this.maxIndex + 1;
      if (count <= 1) return;
      this.index = (this.index - 1 + count) % count;
    },
    next() {
      const count = this.maxIndex + 1;
      if (count <= 1) return;
      this.index = (this.index + 1) % count;
    }
  }
};
</script>

<template>
  <div class="gallery" v-if="galleryItems.length">
    <h2 class="gallery-heading">Bildergalerie</h2>
    <v-row>
      <v-col cols="12" md="10"
        ><p class="gallery-text">{{ bildergallerie.BildergallerieText }}</p>
      </v-col>
      <v-col cols="12" md="2"
        ><div class="gallery-nav">
          <button
            class="gallery-button"
            type="button"
            aria-label="Zurück"
            @click="prev"
          >
            <v-icon class="arrow-icon" size="28">mdi-arrow-left</v-icon>
          </button>
          <button
            class="gallery-button"
            type="button"
            aria-label="Weiter"
            @click="next"
          >
            <v-icon class="arrow-icon" size="28">mdi-arrow-right</v-icon>
          </button>
        </div></v-col
      >
    </v-row>
    <div class="gallery-body">
      <div class="gallery-viewport" ref="viewport">
        <div
          class="gallery-track"
          :style="{ transform: `translateX(-${index * step}px)` }"
        >
          <figure
            class="gallery-item"
            v-for="(item, i) in galleryItems"
            :key="i"
          >
            <img
              class="gallery-image"
              :src="imageUrl(item)"
              :alt="item.Beschreibung"
            />
            <figcaption class="gallery-caption">
              {{ item.Beschreibung }}
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
h2 {
  margin-top: 56px;
  margin-bottom: 16px;
  font-size: 30px;
  letter-spacing: 0.6px;
}
p {
  margin-bottom: 24px !important;
  letter-spacing: 0.32px;
  font-family: "GeometriaLight";
}
.gallery {
  width: 100%;
  margin-bottom: 56px;
}
.gallery-heading {
  font-size: 30px;
  letter-spacing: 0.6px;
}
.gallery-body {
  width: 100%;
}
.gallery-text {
  margin: 0;
}
.gallery-nav {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-bottom: 24px;
}
.gallery-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  justify-content: center;
}
.gallery-button:disabled {
  opacity: 0.3;
  cursor: default;
}
.gallery-viewport {
  overflow: hidden;
  width: 100%;
}
.arrow-icon {
  color: #b40055;
}
.gallery-track {
  display: flex;
  gap: 16px;
  transition: transform 0.3s ease;
}
.gallery-item {
  flex: 0 0 calc((100% - 32px) / 3);
  margin: 0;
}
.gallery-image {
  width: 100%;
  aspect-ratio: 296 / 222;
  height: auto;
  object-fit: cover;
  display: block;
}
.gallery-caption {
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
  color: #1f2b37;
  letter-spacing: 0.24px;
}
@media (max-width: 959px) {
  .gallery-item {
    flex: 0 0 calc((100% - 16px) / 2);
  }
}
@media (max-width: 599px) {
  .gallery-item {
    flex: 0 0 100%;
  }
}
</style>
